import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router";
import { Apis } from "../util/Apis";
import styled, { keyframes } from "styled-components";
import ContainerBackgroundWrapper from "../components/Backgrounds";
import CustomLoading from "../components/CustomLoading";
import NoSorteos from "../components/NoSorteos";
import Text from "../styledComponents/TextStyled";
import useGet from "../hooks/useGet";
import { SiteContext } from "../context/SiteContext";
import Button from "../components/atoms/Buttons";
import HotSeatWinnerContent from "../components/hotseat/HotSeatWinnerContent";
import HotSeatEmptyContent from "../components/hotseat/HotSeatEmptyContent";
import winnerSound from "../assets/sounds/winner.mp3";
import { isWinnerSoundMuted } from "../util/winnerSound";
import axios from "axios";

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(1.035); }
  to { opacity: 1; transform: none; }
`;
const Reveal = styled.div`
  width: 100%;
  height: 100%;
  animation: ${fadeIn} 1.3s cubic-bezier(0.2, 0.7, 0.2, 1) both;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
export default function CongratHotSeatWinner() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { sorteosConf, salaId } = useContext(SiteContext);
  const reveal = location.state?.hotSeatReveal;
  // Reuse the exact result already shown by the 3D scene. Direct visits still
  // load from the API; a state belonging to another draw must never be reused.
  const hasReveal =
    reveal?.id === id && (reveal.winner === null || Number(reveal.winner?.confId) > 0);
  const { loading, data, error, fetchData } = useGet({
    url: `${Apis.SORTEOS}/sorteos/${id}/winner`,
    initialValue: hasReveal ? reveal.winner : undefined,
    auto: !hasReveal,
  });
  const existWinner = Number(data?.confId) > 0;
  const pending = !error && (loading || data === undefined);

  // Confirma el ganador en el servidor (para generar el nro de acta) y vuelve a la lista de sorteos.
  const confirmWinner = () => {
    if (!data?.sorteoWinnerId) {
      navigate("/sorteo-list");
      return;
    }

    axios.post(Apis.SORTEOS + "/sorteo-winner/" + data.sorteoWinnerId + "/confirm").finally(() => {
      navigate("/sorteo-list");
    });
  };

  useEffect(() => {
    if (!existWinner || isWinnerSoundMuted(salaId)) return;
    const audio = new Audio(winnerSound);
    audio.play()?.catch(() => {});
    return () => {
      audio.pause();
    };
  }, [existWinner, salaId]);

  return (
    <ContainerBackgroundWrapper showBackgroundCard={false}>
      {pending ? (
        <CustomLoading />
      ) : error ? (
        <NoSorteos>
          <Text textStyle="small">No se pudo consultar el resultado</Text>
          <Button onClick={() => fetchData()}>REINTENTAR</Button>
        </NoSorteos>
      ) : (
        <Reveal
          data-testid="hotseat-winner-reveal"
          data-screen-reveal-complete={Boolean(hasReveal && reveal.screenRevealComplete)}
          style={(existWinner && !reveal?.fadeIn) || (hasReveal && reveal.emptyRevealComplete) ? { animation: "none" } : undefined}
        >
          {existWinner ? (
            <HotSeatWinnerContent
              winner={data}
              showWinner={sorteosConf?.showWinnerHotSeat}
              celebrate
              onRestart={() => navigate(`/sorteo-animation-hotseat/${id}`)}
              onConfirm={confirmWinner}
            />
          ) : (
            <HotSeatEmptyContent
              onRetry={() => navigate(`/sorteo-animation-hotseat/${id}`)}
              onBack={() => navigate("/sorteo-list")}
            />
          )}
        </Reveal>
      )}
    </ContainerBackgroundWrapper>
  );
}
